import React from "react";
import { EmojiDisplay } from "../comp/EmojiDisplay";
import { Icon } from "../comp/Icon";
import { Editor } from "../comp/Editor";
import { renameExtension } from "../_global";
import { EmojiDisplayContainer } from "../comp/EmojiDisplayContainer";

export class CentrePanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            night: false
        };
        
        this.invert = this.invert.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        // sabe invert state
        if(prevState.night != this.state.night) {
            window.localStorage.setItem("emoji-night", this.state.night);
        }
    }

    componentDidMount() {
        // load invert state
        var state = window.localStorage.getItem("emoji-night");
        
        if(state == "true") {
            this.invert();
        }
    }


    invert() {
        // night mode
        var app = document.getElementById("App2");

        // switch
        if(!this.state.night) {
            // enable night mode
            app.classList.add("invert");
        }
        else {
            // disable night mode
            app.classList.remove("invert");
        }

        this.setState({ night: !this.state.night });
    }

    render() {

        // render finished emoji
        /*var layers = [], total = this.props.layers.length;

        this.props.layers.map((item, i) => {
            // check if active
            var active = false;

            if(i == this.props.active) {
                active = true;
            }

            layers.push(
                <EmojiDisplay 
                    section={item.section} 
                    select={this.props.select}
                    icon={item.item} 
                    key={i} index={i} 
                    info={item}
                    zIndex={total - i}
                    active={active}
                />
            );
        });*/


        // render options
        var options = "buttons options",
            info = "",
            activeItem = "";

        if(this.props.active == -1) {
            // if nothing is selected
            options = "buttons options hidden";
        }
        else {
            activeItem = this.props.layers[this.props.active];

            info = (
                <div className="info">
                    <span>
                        ({this.props.active + 1}) <b> {activeItem.item + renameExtension(activeItem.section)} </b>
                    </span>

                    <span>X Offset: {activeItem.xOffset}px</span>
                    <span>Y Offset: {activeItem.yOffset}px</span>
                    <span>Rotation: {activeItem.rotation}&deg;</span>
                    <span>Scale: {activeItem.scale}x</span>
                    <span>L/R Flipped: {(activeItem.hFlip) ? "✅" : "❌"}</span>
                    <span>U/D Flipped: {(activeItem.vFlip) ? "✅" : "❌"}</span>
                </div>
            )
        }


        return (
            <div className="panel display">
                <div className="buttons top">
                    <button className="give-tooltip" data-tooltip="About" onClick={this.props.about}> <Icon type="fa-info" /> </button>
                    
                    <button className="give-tooltip" data-tooltip="Night mode" onClick={this.invert}> <Icon type="fa-star" /> </button>

                    <button className="give-tooltip" data-tooltip="Load" onClick={this.props.loadOpen}> <Icon type="fa-bars" /> </button>

                    <button className="give-tooltip" data-tooltip="Save" onClick={this.props.save}> <Icon type="fa-save" /> </button>
                    
                    <button className="give-tooltip" data-tooltip="New" onClick={this.props.new}> <Icon type="fa-file" /> </button>
                </div>

                <EmojiDisplayContainer layers={this.props.layers} select={this.props.select} />

                <Editor activeItem={activeItem} options={options} index={this.props.active} edit={this.props.edit} />

                {info}
            </div>
        );
    }
}


CentrePanel.defaultProps = {
    layers: [],
    active: -1
};
